import { gql } from '@apollo/client';

export const FAVOURITE_USER_FRAGMENT = gql`
  fragment FavouriteUserFragment on FavouriteUser {
    userId
    clientId
  }
`;

export const GET_FAVOURITE_USERS = gql`
  ${FAVOURITE_USER_FRAGMENT}
  query GetFavouriteUsers($clientId: String!) {
    getFavouriteUsers(clientId: $clientId) {
      ...FavouriteUserFragment
    }
  }
`;

export const ADD_FAVOURITE_USER = gql`
  mutation AddFavouriteUser($clientId: String!, $userId: String!) {
    addFavouriteUser(clientId: $clientId, userId: $userId)
  }
`;

export const REMOVE_FAVOURITE_USER = gql`
  mutation RemoveFavouriteUser($clientId: String!, $userId: String!) {
    removeFavouriteUser(clientId: $clientId, userId: $userId)
  }
`;
